let rootUrl;

//console.log('node env', process.env.NODE_ENV)

if (process.env.REACT_APP_API_URL) {
  rootUrl = process.env.REACT_APP_API_URL;
  //console.log('has api url', rootUrl);
}
else {
  //console.log('does not have api url');
  rootUrl = 'localhost:4000';
}

export const API_ROOT = `http://${rootUrl}`;
export const API_ENTRY = `${API_ROOT}/api`;
export const API_ENTRY_WS = `ws://${rootUrl}/socket`;



// WEBPACK FOOTER //
// ./src/apiConfig.js